<template>
	<div class="container-fluid">
        <div class="row">
            <div class="div col-md-4" v-for="mesa in mesas" :key="mesa.id" >
                <div class="p-3 border text-white" :class="classeStatus(mesa.status)" @click.prevent="redirectTo(mesa.id)" >
                    <header class="p-1 text-center" >
                        <h2> Mesa {{mesa.id}}</h2>
                    </header>
                    <div class="text-center" >
                        <font-awesome-icon icon="users" v-if="mesa.status === 'a'" size="4x"  />
                        <font-awesome-icon icon="user-slash" v-else-if="mesa.status === 't' " size="4x"  />
                        <font-awesome-icon icon="user-clock" v-else-if="mesa.status === 'f' " size="4x"  />
                        <font-awesome-icon icon="user-times" v-else-if="mesa.status === 'v' " size="4x"  />
                    </div>

                    <div class="container pt-4" >
                        <strong>
                            Geral
                        </strong>
                        <hr class="my-1 bg-white" >
                        <div class="d-flex justify-content-between text-left mb-2" >
                            <span class="flex-fill" >
                                <font-awesome-icon icon="users" /> Minutos: {{mesa.minutos}}
                            </span>

                            <span class="flex-fill">
                                <font-awesome-icon icon="users" /> Total: R$ {{mesa.subtotal}}
                            </span>
                        </div>

                        <strong>
                            Último Pedido
                        </strong>
                        <hr class="my-1 bg-white" >
                        <div class="text-left" >
                            <font-awesome-icon icon="users" /> Tempo: {{$moment(mesa.hora, 'DD-MM-YYYY HH:mm:ss').format('LTS')}}
                        </div>
                        <div class="text-left" >
                            <font-awesome-icon icon="users" /> Produto: {{mesa.produto}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
	export default {
		name: 'tableMap',
		data(){
			return {
				mesas : [],
				tableInfo: {
					name: 'Mesa 01',
					value: 0,
					capacity: 0,
					busy: 0,
					status: 'Vazia',
					timer: ''
				}
			}
		},
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
		methods: {
            redirectTo: function(id){
                this.$router.push({
                    name: 'mesas.mapa.index',
                    params: {
                        id: id
                    }
                })
            },

			classeStatus: function(status){
				switch (status) {
					case 'a':
						return 'bg-primary'
					case 'f':
						return 'bg-dark'
					case 't':
						return 'bg-warning'
					case 'v':
						return 'bg-success'
					default:
						return 'bg-primary'
				}
			},

			getData: function(){
				fetch(server + 'informacoes/mesas', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
				})
					.then(response => {
                        if(response.status == 200){
                            response.json()
                                .then(data => {
                                    if(data.data){
                                        this.mesas = data.response
                                    }else{
                                        console.error('Error exception', '=>', data.message)
                                    }
                                })
                                .catch(error => {
                                    console.error('Error exception', '=>', error.message)
                                })
                        }else{
                            console.error('Error exception', '=>', response.statusText)
                        }
					})
					.catch(error => {
						console.error('Error exception', '=>', error.message)
					})
			}
		},
		mounted(){
			this.getData()
		}
	};
</script>
<style scoped>
	/* .table{
		padding: 1.5rem;
	}

	#wrap-table-info{
		width: 350px;
		height: 100%;
		position: fixed; 
		right: -350px;
		top: 0;
		z-index: 9999;

		transition: all .5s ease-in;
	}

	#wrap-table-info.open{
		right: 0;
		transition: all .5s ease-out;
	}

	#wrap-table-info.open .closeWrapper{
		position: absolute;
		left: -1.5rem;
		top: 0;

		transition: all 0.1s ease-in;
	}

	#wrap-table-info .closeWrapper{
		position: absolute;
		left: 0;
		top: 0;

		transition: all .5s ease-out;
	}

	.bg-ultra-dark{
		background: #212529;
	} */
</style>